
const digest = '1d10b685a99cefb63db4bdcb9ac57e3e57183ca6f587d8105c75b0fe99ab97a7';
const classes = {"wrapper":"_wrapper_1x555_1","formCard":"_formCard_1x555_6","formGroup":"_formGroup_1x555_11","label":"_label_1x555_19","text":"_text_1x555_22","select":"_select_1x555_34","userPicker":"_userPicker_1x555_46","loading":"_loading_1x555_53","note":"_note_1x555_58"};
const css = `._wrapper_1x555_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_1x555_1 ._formCard_1x555_6 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
}
._wrapper_1x555_1 ._formCard_1x555_6 ._formGroup_1x555_11 {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}
._wrapper_1x555_1 ._formCard_1x555_6 ._formGroup_1x555_11 ._label_1x555_19 {
  padding: 0 12px;
}
._wrapper_1x555_1 ._formCard_1x555_6 ._formGroup_1x555_11 ._label_1x555_19 ._text_1x555_22 {
  color: #212357;
  font-weight: 400;
  font-size: 12px;
  padding-left: 20px;
  margin: 0;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_1x555_1 ._formCard_1x555_6 ._formGroup_1x555_11 ._select_1x555_34 {
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-top: 0;
  margin-bottom: 10px;
}
._wrapper_1x555_1 ._userPicker_1x555_46 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
._wrapper_1x555_1 ._loading_1x555_53 {
  display: flex;
  justify-content: center;
}

._note_1x555_58 {
  text-align: center;
  color: #fff;
  font-size: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  